import FiltersSectionSkeleton from '@/components/Skeletons/FiltersSectionSkeleton';
import TableSkeleton from '@/components/Skeletons/TableSkeleton';
import TopSectionSkeleton from '@/components/Skeletons/TopSectionSkeleton';
import PageWrapper from '@/hoc/PageWrapper';
import { createBrowserRouter, Navigate } from 'react-router-dom';

const DashboardSkeleton = () => (
  <div>
    <TopSectionSkeleton />
    <FiltersSectionSkeleton />
    <TableSkeleton />
  </div>
);

//Lazy loading element
const AuthPage = PageWrapper(
  () => import('@/Pages/AuthPage/AuthPage'),
  DashboardSkeleton,
);
const Dashboard = PageWrapper(
  () => import('@/Pages/DashboardPage/Dashboard'),
  DashboardSkeleton,
);

const routes = createBrowserRouter(
  [
    {
      path: '/',
      element: <Navigate to="/dashboard" />,
    },
    {
      path: '/login',
      element: <AuthPage />,
    },
    {
      path: '/dashboard',
      element: <Dashboard />,
    },
    {
      path: '*',
      element: <Navigate to="/" />,
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);

export default routes;
